<template>
	<div :class="[multipage === true ? 'multi-page' : 'single-page', 'home-page']">
		<img v-if="level > 3" alt="" class="u-title" style="width:100%" src="../assets/images/home-img/home-village.jpg" />
		<a-carousel arrows :dots="false" class="scorll-row">
			<div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 1"><a-icon type="left-circle" /></div>
			<div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px"><a-icon type="right-circle" /></div>
			<div>
				<a-row :gutter="8" class="count-info" v-if="level <= 3">
					<a-col :lg="6" :md="12" :sm="24">
						<a-card class="white-card">
							<div class="left-content">
								<div>
									<span class="round-bg round-bg1">理赔总户数(户)</span>
									<span style="color: #1a8dee;font-weight:700;" v-if="topItem.length > 0">{{ payNumber || 0 }}</span>
									<span style="color: #1a8dee;font-weight:700;" v-else>0</span>
								</div>
								<div>
									<span class="round-bg round-bg1">理赔总面积(亩)</span>
									<span style="color: #1a8dee;font-weight:700;" v-if="topItem.length > 0">{{ payArea || 0 }}</span>
									<span style="color: #1a8dee;font-weight:700;" v-else>0</span>
								</div>
							</div>
							<div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-chart.png" /></div>
						</a-card>
					</a-col>
					<a-col :lg="6" :md="12" :sm="24" v-for="(item, index) in topItem1" v-if="index < 3" :key="index">
						<a-card class="white-card">
							<div class="left-content">
								<div>
									<span :class="dynamicStateRoundBg(index)" style="font-size:15px;">{{ item.plantTypeName }}</span>
								</div>
								<div>
									<span style="color:#333">理赔面积(亩)</span>
									<span :class="dynamicStateClassName(index)" v-if="topItem.length > 0">{{ item.payArea || 0 }}</span>
									<span :class="dynamicStateClassName(index)" v-else>0</span>
								</div>
								<div>
									<span style="color:#333">理赔金额(元)</span>
									<span :class="dynamicStateClassName(index)" v-if="topItem.length > 0">{{ item.payAmount || 0 }}</span>
									<span :class="dynamicStateClassName(index)" v-else>0</span>
								</div>
							</div>
							<!-- <div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-rice.png" /></div> -->
							<div class="right-content"><img alt="logo" class="u-title" :src="dynamicStateImg(index)" /></div>
						</a-card>
					</a-col>
					<!-- <a-col :lg="6" :md="12" :sm="24">
						<a-card class="white-card">
							<div class="left-content">
								<div><span class="round-bg round-bg3" style="font-size:15px;">大豆政策性保险</span></div>
								<div>
									<span style="color:#333">理赔面积(亩)</span>
									<span style="color: #00d5b2;font-weight:700;" v-if="topItem.length > 0">{{ topItem[1].payArea || 0 }}</span>
									<span style="color: #00d5b2;font-weight:700;" v-else>0</span>
								</div>
								<div>
									<span style="color:#333">理赔金额(元)</span>
									<span style="color: #00d5b2;font-weight:700;" v-if="topItem.length > 0">{{ topItem[1].payAmount || 0 }}</span>
									<span style="color: #00d5b2;font-weight:700;" v-else>0</span>
								</div>
							</div>
							<div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-beans.png" /></div>
						</a-card>
					</a-col>
					<a-col :lg="6" :md="12" :sm="24">
						<a-card class="white-card">
							<div class="left-content">
								<div><span class="round-bg round-bg4" style="font-size:15px;">玉米政策性保险</span></div>
								<div>
									<span style="color:#333">理赔面积(亩)</span>
									<span style="color: #00d5b2;font-weight:700;" v-if="topItem.length > 0">{{ topItem[2].payArea || 0 }}</span>
									<span style="color: #00d5b2;font-weight:700;" v-else>0</span>
								</div>
								<div>
									<span style="color:#333">理赔金额(元)</span>
									<span style="color: #00d5b2;font-weight:700;" v-if="topItem.length > 0">{{ topItem[2].payAmount || 0 }}</span>
									<span style="color: #00d5b2;font-weight:700;" v-else>0</span>
								</div>
							</div>
							<div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-corn.png" /></div>
						</a-card>
					</a-col> -->
				</a-row>
			</div>

			<div v-for="(m, i) in topItem2.length" :key="i">
				<a-row :gutter="8" class="count-info" v-if="level <= 3" style="">
					<a-col :lg="6" :md="12" :sm="24" v-for="(item, index) in topItem2[i]" :key="index">
						<a-card class="white-card">
							<div class="left-content">
								<div>
									<span :class="dynamicStateRoundBg(index + 3)" style="font-size:15px;">{{ item.plantTypeName }}</span>
								</div>
								<div>
									<span style="color:#333">理赔面积(亩)</span>
									<span :class="dynamicStateClassName(index + 3)" v-if="topItem.length > 0">{{ item.payArea || 0 }}</span>
									<span :class="dynamicStateClassName(index + 3)" v-else>0</span>
								</div>
								<div>
									<span style="color:#333">理赔金额(元)</span>
									<span :class="dynamicStateClassName(index + 3)" v-if="topItem.length > 0">{{ item.payAmount || 0 }}</span>
									<span :class="dynamicStateClassName(index + 3)" v-else>0</span>
								</div>
							</div>
							<div class="right-content"><img alt="logo" class="u-title" :src="dynamicStateImg(index + 3)" /></div>
						</a-card>
					</a-col>
				</a-row>
			</div>

			<!-- <div>
				<a-row :gutter="8" class="count-info" v-if="level <= 3" style="">
					<a-col :lg="6" :md="12" :sm="24">
						<a-card class="white-card">
							<div class="left-content">
								<div><span class="round-bg round-bg5" style="font-size:15px;">小麦政策性保险</span></div>
								<div>
									<span style="color:#333">理赔面积(亩)</span>
									<span style="color: #ff9023;font-weight: 700;" v-if="topItem.length > 0">{{ topItem[2].payArea || 0 }}</span>
									<span style="color: #ff9023;font-weight: 700;" v-else>0</span>
								</div>
								<div>
									<span style="color:#333">理赔金额(元)</span>
									<span style="color: #ff9023;font-weight: 700;" v-if="topItem.length > 0">{{ topItem[2].payAmount || 0 }}</span>
									<span style="color: #ff9023;font-weight: 700;" v-else>0</span>
								</div>
							</div>
							<div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-wheat.png" /></div>
						</a-card>
					</a-col>
				</a-row>
			</div> -->
		</a-carousel>

		<div v-if="level <= 3">
			<a-row :gutter="8" class="count-info">
				<a-col :lg="24" :md="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title u-chart-subTitle">本年度各险种报案与理赔情况</div>
						<SettlementClaimsChart ref="SettlementClaimsChart1" :id="'SettlementClaimsChart1'" />
					</a-card>
				</a-col>
			</a-row>
			<a-row :gutter="8" class="count-info">
				<a-col :lg="6" :md="12" :sm="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title">各保险公司理赔比例(%)</div>
						<!-- <AreaPercentageChart ref="areaPercentageChart" :id="'areaPercentageChart1'" /> -->
						<SettlementProportionChart ref="SettlementProportionChart" :id="'SettlementProportionChart'" />
					</a-card>
				</a-col>
				<a-col :lg="18" :md="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title">各保险公司保险收益(元)</div>
						<!-- <ProvinceInsuredChart ref="provinceInsuredChart" :id="'provinceInsuredChart1'" /> -->
						<SettlementEarningsChart ref="SettlementEarningsChart" :id="'SettlementEarningsChart'" />
					</a-card>
				</a-col>
			</a-row>
			<a-row :gutter="8" class="count-info">
				<a-col :lg="12" :md="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title">各保险公司理赔完成度</div>
						<!-- <CityInsuranceChart ref="cityInsuranceChart" :id="'cityInsuranceChart1'" /> -->
						<SettlementCompletenessChart ref="SettlementCompletenessChart" :id="'SettlementCompletenessChart'" />
					</a-card>
				</a-col>
				<a-col :lg="12" :md="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title">各保险公司理赔时效对比(天)</div>
						<!-- <ThreeYearAreasChart ref="threeYearAreasChart" :id="'threeYearAreasChart1'" /> -->
						<SettlementContrastagingChart ref="SettlementContrastagingChart" :id="'SettlementContrastagingChart'" />
					</a-card>
				</a-col>
			</a-row>
			<a-row :gutter="8" class="count-info">
				<a-col :lg="24" :md="24" class="visit-count-wrapper">
					<a-card class="visit-count">
						<div class="u-chart-title" style="margin-bottom:0">黑龙江省各区县理赔情况</div>

						<a-col :lg="11" :md="24" class="visit-count-wrapper"><MapChart @mapChartFun="handleMapChartOnClick" :id="'mapId1'" /></a-col>
						<a-col :lg="13" :md="24" class="visit-count-wrapper part-2">
							<a-col :lg="12" :md="24" class="visit-count-wrapper" style="border-right:1px solid #ddd;border-bottom:1px solid #ddd;">
								<div class="u-chart-title u-chart-subTitle">各灾情理赔情况</div>
								<!-- <CompleteRateChart ref="completeRateChart2" :id="'completeRateChart4'" /> -->
								<SettlementClaimsituationChart ref="SettlementClaimsituationChart" :id="'SettlementClaimsituationChart'" />
							</a-col>

							<a-col :lg="12" :md="24" class="visit-count-wrapper" style="border-bottom:1px solid #ddd;">
								<div class="u-chart-title u-chart-subTitle">各险种理赔情况</div>
								<!-- <NewSubjectChart ref="newSubjectChart1" :id="'newSubjectChart2'" /> -->
								<SettlementInsuranceClaimsChart ref="SettlementInsuranceClaimsChart" :id="'SettlementInsuranceClaimsChart'" />
							</a-col>

							<a-col :lg="12" :md="24" class="visit-count-wrapper" style="border-right:1px solid #ddd">
								<div class="u-chart-title u-chart-subTitle">各保险公司报案理赔情况</div>
								<!-- <ByInsuranceChart ref="ByInsuranceChart1" :id="'ByInsuranceChart2'" /> -->
								<SettlementReportClaims ref="SettlementReportClaims" :id="'SettlementReportClaims'" />
							</a-col>

							<a-col :lg="12" :md="24" class="visit-count-wrapper">
								<div class="u-chart-title u-chart-subTitle">各保险公司定损标准(元/亩)</div>
								<!-- <ProvinceInsurancePayChart ref="provinceInsurancePayChart1" :id="'provinceInsurancePayChart2'" /> -->
								<SettlementFeeStandardChart ref="SettlementFeeStandardChart" :id="'SettlementFeeStandardChart'" />
							</a-col>
							<!-- </a-row> -->
						</a-col>
					</a-card>
				</a-col>
			</a-row>
		</div>
		<div v-else></div>
	</div>
</template>
<script>
import HeadInfo from '@/views/common/HeadInfo';
import { mapState } from 'vuex';
import moment from 'moment';
import echarts from 'echarts';
//import Settlement from './Settlement';

moment.locale('zh-cn');
import AreaPercentageChart from '@/components/homechart/AreaPercentageChart'; //各险种投保面积占比(%)
import CompleteRateChart from '@/components/homechart/CompleteRateChart'; //政策保险完成比列(%)
import ProvinceInsuredChart from '@/components/homechart/ProvinceInsuredChart'; //全省历年投保情况分析（亩）
import CityInsuranceChart from '@/components/homechart/CityInsuranceChart'; //各地市投保情况（亩）
import ThreeYearAreasChart from '@/components/homechart/ThreeYearAreasChart'; //各保险公司三年投保面积（亩）
import ProvinceInsurancePayChart from '@/components/homechart/ProvinceInsurancePayChart'; //各保险公司保费支付情况(元)
import ByInsuranceChart from '@/components/homechart/ByInsuranceChart'; //各保险公司承保情况（亩）
import NewSubjectChart from '@/components/homechart/NewSubjectChart'; //农户/新型经营主体投保情况
import MapChart from '@/components/homechart/MapChart'; //全国地图

// 理赔弹窗echart
import SettlementClaimsChart from '@/components/homechart/SettlementClaimsChart'; //本年度各险种报案与理赔情况
import SettlementProportionChart from '@/components/homechart/SettlementProportionChart'; //各保险公司理赔比例
import SettlementEarningsChart from '@/components/homechart/SettlementEarningsChart'; //各保险公司保险收益(元)
import SettlementCompletenessChart from '@/components/homechart/SettlementCompletenessChart'; //各保险公司理赔完成度
import SettlementContrastagingChart from '@/components/homechart/SettlementContrastagingChart'; //各保险公司理赔时效对比(天)
import SettlementClaimsituationChart from '@/components/homechart/SettlementClaimsituationChart'; //各灾情理赔情况
import SettlementInsuranceClaimsChart from '@/components/homechart/SettlementInsuranceClaimsChart'; //各险种理赔情况
import SettlementReportClaims from '@/components/homechart/SettlementReportClaims'; //各保险公司报案理赔情况
import SettlementFeeStandardChart from '@/components/homechart/SettlementFeeStandardChart'; //各保险公司定损标准(元/亩)

export default {
	name: 'HomePage2',
	components: {
		HeadInfo,
		MapChart,
		AreaPercentageChart,
		CompleteRateChart,
		ProvinceInsuredChart,
		CityInsuranceChart,
		ThreeYearAreasChart,
		ProvinceInsurancePayChart,
		ByInsuranceChart,
		NewSubjectChart,

		// 理赔弹窗echart
		SettlementClaimsChart, //本年度各险种报案与理赔情况
		SettlementProportionChart, //各保险公司理赔比例
		SettlementEarningsChart, //各保险公司保险收益(元)
		SettlementCompletenessChart, //各保险公司理赔完成度
		SettlementContrastagingChart, //各保险公司理赔时效对比(天)
		SettlementClaimsituationChart, //各灾情理赔情况
		SettlementInsuranceClaimsChart, //各险种理赔情况
		SettlementReportClaims, //各保险公司报案理赔情况
		SettlementFeeStandardChart //各保险公司定损标准(元/亩)
	},
	data() {
		return {
			// demoVisible:false,//理赔弹窗默认关闭
			level: this.$store.state.account.user.level,
			topItem: [], //头部项目
			topItem1: [], //固定项目
			topItem2: [], //其余项目

			SettlementClaimsData1: {}, //本年度各险种报案与理赔情况
			SettlementProportionData: {}, //各保险公司理赔比例
			SettlementEarningsData: {}, //各保险公司保险收益(元)
			SettlementCompletenessData: {}, //各保险公司理赔完成度
			SettlementContrastagingData: {}, //各保险公司理赔失效对比(天)
			SettlementClaimsituationData: {}, //各灾情理赔情况
			SettlementInsuranceClaimsData: {}, //各险种理赔情况
			SettlementReportClaimsData: {}, //各保险公司报案理赔情况
			SettlementFeeStandardChartData: {} //各保险公司定损标准(元/亩)
		};
	},
	computed: {
		...mapState({
			multipage: state => state.setting.multipage,
			user: state => state.account.user
		}),
		avatar() {
			return `static/avatar/${this.user.avatar}`;
		}
	},
	methods: {
		// 动态字体颜色
		dynamicStateClassName(index) {
			return 'topItemColor' + (index + 1);
		},
		// 动态标题框颜色
		dynamicStateRoundBg(index) {
			return 'round-bg' + (index + 2);
		},
		// 动态加载图片
		dynamicStateImg(index) {
			if (index === 0) {
				return require('@/assets/images/home-img/icon-rice.png');
			} else if (index === 1) {
				return require('@/assets/images/home-img/icon-beans.png');
			} else if (index === 2) {
				return require('@/assets/images/home-img/icon-corn.png');
			} else {
				return require('@/assets/images/home-img/icon-wheat.png');
			}
		},
		// 顶部理赔面积以及总金额
		listFeeBase() {
			this.$get('/statisticsFeeBase/listFeeBase', {
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || '',
				year: moment().format('YYYY')
			})
				.then(r => {
					let data = r.data.data.listFeeBase;
					if (data.length <= 0) return;
					//取前三个险种及合计信息
					let newData = [];
					data.map(item => {
						if (item.plantTypeName.indexOf('水稻') != -1) {
							newData[0] = item;
						} else if (item.plantTypeName.indexOf('大豆') != -1) {
							newData[1] = item;
						} else if (item.plantTypeName.indexOf('玉米') != -1) {
							newData[2] = item;
						} else if (item.plantTypeName.indexOf('小麦') != -1) {
							newData[3] = item;
						}
					});
					this.topItem = [...newData];
					// 头部数据第一组topItem1,第二组topItem2
					if (this.topItem.length <= 3) {
						this.topItem1 = [...this.topItem];
						this.topItem2 = [];
					}
					// 头部数据第一组topItem1,第二组topItem2
					if (this.topItem.length > 3) {
						this.topItem1 = this.topItem.slice(0, 3);
						// mid为第二组topItem2到结束
						let mid = this.topItem.slice(3);
						/* 每一组四个，计算出除固定的还有几组 */
						let forLength = Math.floor(mid.length % 4) === 0 ? Math.floor(mid.length / 4) : Math.floor(mid.length / 4) + 1;
						for (let m = 0; m < forLength; m++) {
							this.topItem2[m] = mid.slice(m, m + 4);
						}
					}
					//this.topItem[3] = sumItem; //把总和拼接到数组中
					this.payArea = r.data.data.payArea; //理赔总面积
					this.payNumber = r.data.data.payNumber; //理赔总户数
					// this.topItem.unshift(this.payArea,this.payNumber)
					// console.log(this.topItem)
					if (this.level > 3) return;
				})
				.catch(e => {
					//console.log('err:', e);
				});
		},
		//本年度各险种报案与理赔情况
		reportPay() {
			this.$get('/statisticsFeeBase/reportPay', {
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || '',
				year: moment().format('YYYY')
			})
				.then(r => {
					let data = r.data.data;
					if (data && data.source.length > 0) {
						this.SettlementClaimsData1 = {
							chartHeight: 240,
							date: data.date,
							dataset: {
								dimensions: data.dimensions,
								source: data.source
							}
						};
					} else {
						this.SettlementClaimsData1 = {
							chartHeight: 240,
							date: ' ',
							dataset: {
								dimensions: [''],
								source: []
							}
						};
					}
					this.$refs.SettlementClaimsChart1.initMap(this.SettlementClaimsData1);
				})
				.catch(() => {});
		},
		// 各保险公司理赔比例(%)
		payRatio() {
			this.$get('/statisticsFeeBase/payRatio', {
				year: moment().format('YYYY'),
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || ''
			})
				.then(r => {
					//返回数据
					let data = r.data.data;
					if (data && data.dataset.length > 0) {
						this.SettlementProportionData = {
							chartHeight: 240,
							date: data.date,
							dataset: data.dataset
						};
					} else {
						this.SettlementProportionData = {
							chartHeight: 240,
							date: '',
							dataset: ''
						};
					}
					// console.log(this.SettlementProportionData)
					this.$refs.SettlementProportionChart.initMap(this.SettlementProportionData);
				})
				.catch(() => {});
		},
		// 各保险公司保险收益(元)
		payEarnings() {
			this.$get('/statisticsFeeBase/payEarnings', {
				year: moment().format('YYYY'),
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || ''
			})
				.then(r => {
					let data = r.data.data;
					if (data.length <= 0) return;
					this.SettlementEarningsData = {
						date: data.date,
						dataset: {
							// dimensions: ['headCompanyName', '保费收入', '理赔支出', '收益情况'],
							dimensions: data.dataset.dimensions,
							source: data.dataset.source
						}
					};
					this.$refs.SettlementEarningsChart.initMap(this.SettlementEarningsData);
				})
				.catch(() => {});
		},
		//各保险公司理赔完成度
		payClaims() {
			this.$get('/statisticsFeeBase/payClaims', {
				year: moment().format('YYYY'),
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || ''
			})
				.then(r => {
					let data = r.data.data;
					this.SettlementCompletenessData = {
						date: data.date,
						dataset: {
							// dimensions: ['headCompanyName', '报案数量', '完成数量'],
							dimensions: data.dataset.dimensions,
							source: data.dataset.source
						}
					};
					// console.log(this.SettlementCompletenessData);
					this.$refs.SettlementCompletenessChart.initMap(this.SettlementCompletenessData);
				})
				.catch(() => {});
		},
		//各保险公司理赔时效对比(天)
		payAging() {
			this.$get('/statisticsFeeBase/payAging', {
				province: this.$store.state.account.user.province || '230000000000',
				city: this.$store.state.account.user.city || '',
				county: this.$store.state.account.user.county || '',
				year: moment().format('YYYY')
			})
				.then(r => {
					let data = r.data.data;
					if (data.length <= 0) return;
					let createDate = data.date;
					this.SettlementContrastagingData = {
						date: createDate,
						dataset: {
							// dimensions: ['headCompanyName', '平均完成时间', '平均查勘时间', '平均定损时间'],
							dimensions: data.dataset.dimensions,
							source: data.dataset.source
						}
					};
					//console.log(this.SettlementContrastagingData);
					this.$refs.SettlementContrastagingChart.initMap(this.SettlementContrastagingData);
				})
				.catch(() => {});
		},

		//黑龙江省各区县理赔情况
		eachDistrictCounty(params) {
			// 各灾情理赔情况
			this.$get('/statisticsFeeBase/payAffected', Object.assign({ year: moment().format('YYYY') }, { ...params }))
				.then(r => {
					//返回数据
					let data = r.data.data;
					if (data && data.dataset.length > 0) {
						for (let i = 0; i < data.dataset.length; i++) {
							let item = data.dataset[i].source;
							for (let innerI = 0; innerI < item.length; innerI++) {
								let innerItem = item[innerI];
								innerItem.type = innerItem.type + '灾害';
							}
						}
						this.SettlementClaimsituationData = {
							chartHeight: 240,
							date: data.date,
							dataset: data.dataset
						};
					} else {
						this.SettlementClaimsituationData = {
							chartHeight: 240,
							date: '',
							dataset: [{ source: [] }, { source: [] }]
						};
					}
					this.$refs.SettlementClaimsituationChart.initMap(this.SettlementClaimsituationData);
				})
				.catch(() => {});
			// 各险种理赔情况
			this.$get('/statisticsFeeBase/payPlantType', Object.assign({ year: moment().format('YYYY') }, { ...params }))
				.then(r => {
					//返回数据
					let data = r.data.data;
					if (data && data.dataset.length > 0) {
						this.SettlementInsuranceClaimsData = {
							chartHeight: 240,
							date: data.date,
							dataset: data.dataset
						};
					} else {
						this.SettlementInsuranceClaimsData = {
							chartHeight: 240,
							date: '',
							dataset: [{ source: [] }, { source: [] }]
						};
					}
					this.$refs.SettlementInsuranceClaimsChart.initMap(this.SettlementInsuranceClaimsData);
				})
				.catch(() => {});

			// 各保险公司报案理赔情况
			this.$get('/statisticsFeeBase/payReport', Object.assign({ year: moment().format('YYYY') }, { ...params }))
				.then(r => {
					let data = r.data.data;
					if (data && data.dataset.source.length > 0) {
						this.SettlementReportClaimsData = {
							date: data.date,
							dataZoom: data.dataset.source.length > 4 ? true : false, //超出范围滚动条
							dataset: {
								dimensions: data.dataset.dimensions,
								source: data.dataset.source
							}
						};
					} else {
						this.SettlementReportClaimsData = {
							chartHeight: 240,
							date: ' ',
							dataset: {
								dimensions: [''],
								source: []
							}
						};
					}

					this.$refs.SettlementReportClaims.initMap(this.SettlementReportClaimsData);
				})
				.catch(() => {});
			// 各保险公司定损标准(元/亩)
			this.$get('/statisticsFeeBase/feeStandard', Object.assign({ year: moment().format('YYYY') }, { ...params }))
				.then(r => {
					let data = r.data.data;
					if (data && data.dataset.source.length > 0) {
						this.SettlementFeeStandardChartData = {
							date: data.date,
							dataZoom: data.dataset.source.length > 3 ? true : false, //超出范围滚动条
							dataset: {
								dimensions: data.dataset.dimensions,
								source: data.dataset.source
							}
						};
					} else {
						this.SettlementFeeStandardChartData = {
							chartHeight: 240,
							date: ' ',
							dataset: {
								dimensions: [''],
								source: []
							}
						};
					}

					this.$refs.SettlementFeeStandardChart.initMap(this.SettlementFeeStandardChartData);
				})
				.catch(() => {});
		},

		// 点击地图联动得到省市区参数
		handleMapChartOnClick(backParams) {
			//console.log('父backParams:', backParams);
			let level = backParams.level;
			//console.log('level:', level);
			let queryparams = {};
			if (level === 0) {
				queryparams = {
					province: this.$store.state.account.user.province || '230000000000',
					city: '',
					county: ''
				};
			} else if (level === 1) {
				queryparams = {
					province: this.$store.state.account.user.province || '230000000000',
					city: backParams.value + '000000',
					county: ''
				};
			} else {
				queryparams = {
					province: this.$store.state.account.user.province || '230000000000',
					city: '',
					county: backParams.value + '000000'
				};
			}
			// console.log(queryparams);
			this.eachDistrictCounty(queryparams);
			// console.log(code, level)
		},
		// 图表重置
		resizeCountry() {
			//本年度各险种报案与理赔情况
			this.$refs.SettlementClaimsChart1.initMap(this.SettlementClaimsData1);
			this.$refs.SettlementClaimsChart1.listenResize();
			//各保险公司理赔比例(%)
			this.$refs.SettlementProportionChart.initMap(this.SettlementProportionData);
			this.$refs.SettlementProportionChart.listenResize();
			// 各保险公司理赔完成度
			this.$refs.SettlementCompletenessChart.initMap(this.SettlementCompletenessData);
			this.$refs.SettlementCompletenessChart.listenResize();
			// 各保险公司理赔失效对比(天)
			this.$refs.SettlementContrastagingChart.initMap(this.SettlementContrastagingData);
			this.$refs.SettlementContrastagingChart.listenResize();
			// 各灾情理赔情况
			this.$refs.SettlementClaimsituationChart.initMap(this.SettlementClaimsituationData);
			this.$refs.SettlementClaimsituationChart.listenResize();
			// 各险种理赔情况
			this.$refs.SettlementInsuranceClaimsChart.initMap(this.SettlementInsuranceClaimsData);
			this.$refs.SettlementInsuranceClaimsChart.listenResize();
			// 各保险公司报案理赔情况
			this.$refs.SettlementReportClaims.initMap(this.SettlementReportClaimsData);
			this.$refs.SettlementReportClaims.listenResize();
			// 各保险公司定损标准(元/亩)
			this.$refs.SettlementFeeStandardChart.initMap(this.SettlementFeeStandardChartData);
			this.$refs.SettlementFeeStandardChart.listenResize();
		},
		initCountry() {}
	},
	created() {
		if (this.level <= 3) {
			//// 顶部理赔面积以及总金额
			this.listFeeBase();
			//本年度各险种报案与理赔情况
			this.reportPay();
			// 各保险公司理赔比例
			this.payRatio();
			//各保险公司理赔时效对比(天)
			this.payAging();
			//各保险公司保险收益(元)
			this.payEarnings();
			//各保险公司理赔完成度
			this.payClaims();
			//黑龙江省各区县理赔情况
			this.eachDistrictCounty({
				province: this.$store.state.account.user.province || '230000000000', //省
				city: this.$store.state.account.user.city || '', //市
				county: this.$store.state.account.user.county || '' //县
			});
		}
	},
	mounted() {
		//重置图表大小
		window.addEventListener('resize', () => {
			if (this.level <= 3) {
				/**
				 * 省市统计
				 */
				this.resizeCountry();
			} else {
				// this.resizeVillages()
			}
		});
	},

	beforeDestroy() {
		// window.removeEventListener("resize");
	}
};
</script>
<style lang="less" scoped>
// 动态添加顶部颜色
// 水稻政策性保险
.home-page {
	.white-card {
		.topItemColor1 {
			color: rgba(26, 141, 238, 1) !important;
			font-weight: 700;
		}
	}
}
// 大豆政策性保险
.home-page {
	.white-card {
		.topItemColor2 {
			color: #12cdcc !important;
			font-weight: 700;
		}
	}
}

// 玉米政策性保险
.home-page {
	.white-card {
		.topItemColor3 {
			color: #00d5b2 !important;
			font-weight: 700;
		}
	}
}

// 小麦政策性保险
.home-page {
	.white-card {
		.topItemColor4 {
			color: rgba(255, 144, 35, 1) !important;
			font-weight: 700;
		}
	}
}

.home-page {
	.part-2 {
		padding: 0 !important;
		// height: 550px;
		border-left: 1px solid #ddd;
		display: flex;
		flex-wrap: wrap;
		.visit-count-wrapper.ant-col-12 {
			padding: 0;
			display: flex;
			height: 240px;
			flex-direction: column;
			:nth-child(2) {
				flex-grow: 1;
			}
		}
	}

	.white-card {
		background: #fff;
		border-radius: 8px;
		padding: 10px;
		min-height: 90px;
		overflow: hidden;
		.ant-card-body {
			min-height: 90px;
			display: flex;
			justify-content: space-between;
		}
		.left-content {
			flex-grow: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			div {
				margin: 2px 0;
				span:nth-child(2) {
					font-size: 18px;
					color: #000;
					padding-left: 5px;
				}
			}
		}
		.right-content {
			line-height: 100%;
			width: 66px;
			padding: 5px;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 100%;
			}
		}
	}
	.round-bg {
		border-radius: 20px;
		color: rgba(26, 141, 238, 1);
		background: rgba(26, 141, 238, 0.1);
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		text-align: center;
	}
	// 水稻政策性保险
	.round-bg2 {
		border-radius: 20px;
		color: rgba(26, 141, 238, 1);
		background: rgba(26, 141, 238, 0.1);
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		text-align: center;
		color: rgba(70, 173, 229, 1);
		background: rgba(70, 173, 229, 0.1);
	}
	// 大豆政策性保险
	.round-bg3 {
		border-radius: 20px;
		color: rgba(26, 141, 238, 1);
		background: rgba(26, 141, 238, 0.1);
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		text-align: center;
		color: rgba(18, 205, 204, 1);
		background: rgba(18, 205, 204, 0.1);
	}
	// 玉米政策性保险
	.round-bg4 {
		border-radius: 20px;
		color: rgba(26, 141, 238, 1);
		background: rgba(26, 141, 238, 0.1);
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		text-align: center;
		color: rgba(0, 213, 178, 1);
		background: rgba(0, 213, 178, 0.1);
	}
	// 小麦政策性保险
	.round-bg5 {
		border-radius: 20px;
		color: rgba(26, 141, 238, 1);
		background: rgba(26, 141, 238, 0.1);
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		text-align: center;
		color: #ff9023;
		background: rgba(255, 144, 35, 0.1);
	}

	/deep/ .not-menu-page {
		background: none !important;
		padding: 0 !important;
	}
	/deep/ .ant-card {
		margin-left: 5px;
		margin-right: 3px;
		margin-bottom: 16px;
	}
	/deep/ .ant-card-body {
		padding: 0 !important;
	}
	.u-chart-title {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding: 8px;
		margin-bottom: 20px;
		text-align: center;
		color: #333;
		font-size: 15px;
		font-weight: bold;
	}
	.u-chart-subTitle {
		font-size: 14px;
		font-weight: normal;
		color: #333;
		border-bottom: none;
		margin-bottom: 10px;
	}
	.visit-count {
		.u-chart-content {
			// width: 380px;
			margin: 0 auto;
		}
	}
}

/* 轮播 */
.home-page /deep/ .scorll-row {
	margin-bottom: 10px;
}
.home-page /deep/ .scorll-row .ant-card {
	margin-bottom: 0;
}
.ant-carousel .slick-prev,
.ant-carousel .slick-next {
	top: 47% !important;
}
.ant-carousel .slick-slide {
	text-align: center;
	overflow: hidden;
}
.ant-carousel .custom-slick-arrow {
	width: 25px;
	height: 25px;
	color: #999 !important;
	opacity: 0.6;
}
.ant-carousel .custom-slick-arrow i {
	font-size: 1.6rem;
}
.ant-carousel .custom-slick-arrow:before {
	display: none;
}
.ant-carousel .custom-slick-arrow:hover {
	opacity: 1;
}
.ant-carousel .slick-slide h3 {
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage2.vue